import React from "react";
// Import pages
import Nav from "./components/Nav";
import AboutPage from "./pages/AboutPage";
import GalleryPage from "./pages/GalleryPage";
import ProductsPage from "./pages/ProductsPage";
// import ReservationPage from './pages/ReservationPage';
import ReservationPageTel from './pages/ReservationPageTel';
import Footer from "./components/Footer"
import GlobalStyle from "./components/GlobalStyle";
import ScrollTop from "./components/ScrollTop";

// Router
import {Routes, Route, useLocation} from 'react-router-dom';
//Animation
import {AnimatePresence} from 'framer-motion';

function App() {
  const location = useLocation();
  return (
    <div className="App">
      <GlobalStyle />
      <ScrollTop />
      <Nav />
      <AnimatePresence exitBeforeEnter>
        <Routes location = {location} key={location.pathname}>
          <Route path="/" exact element={<AboutPage />} />
          <Route path="products" exact element={<ProductsPage />}/>
          <Route path="gallery" exact element={<GalleryPage />}/>
          {/* <Route path="reservation" exact element={<ReservationPage />}/> */}
          <Route path="reservation" exact element={<ReservationPageTel />}/>
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;
